<template>
  <div class="content custom-content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <router-view
          @cotentLoading="cotentLoading"
          @showNotification="notifyVue"
          @forceRerenderMenu="forceRerenderMenu"
        ></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import { Notification } from 'element-ui';

export default {
  methods: {
    cotentLoading(value) {
      this.$emit("dashLoading", value ? value : false);
    },

    forceRerenderMenu() {
      this.$emit("forceRerenderMenu");
    },

    notifyVue(data) {
      switch (data.type) {
        case "success":
          Notification.success(data);
          break;
        case "warning":
          Notification.warning(data);
          break;
        case "info":
          Notification.info(data);
          break;
        case "danger":
        case "error":
          Notification.error(data);
          break;
      }
    },
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
</style>
